<label class="toggle-switch" [class.disabled]="disabled">
  <input
    class="toggle-switch-input"
    type="checkbox"
    role="switch"
    [attr.id]="controlId ?? generatedRandomId"
    [attr.aria-label]="ariaLabel"
    [attr.aria-checked]="isChecked"
    [checked]="isChecked"
    [disabled]="disabled"
    (change)="toggle()" />
  <span class="toggle-slider"></span>
</label>
